module.exports = __webpack_public_path__ + "static/media/logo-icon.7f811eaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/brand/logo-icon.png
// module id = 740
// module chunks = 147